/**
 * Arquivo: src/services/auth.ts
 * Versão: 6.0.0
 * Data: 08/10/2026
 */
import { apiJson } from './api'
import { neonAuth } from './neonAuth'

export type PapelUsuario = {
  id:string
  codigo:string
  nome:string
  descricao?:string|null
  ativo?:boolean
  permissions?:string[]
}

export type UsuarioAdministracao = {
  user_id:string
  nome?:string
  email:string
  perfil?:string
  ativo:boolean
  must_change_password?:boolean
  ultimo_acesso?:string|null
  roles:PapelUsuario[]
}

export type MinhaIdentidade = {
  id:string
  name:string
  email:string
  active:boolean
  mustChangePassword:boolean
  lastAccess?:string|null
  member?:{base_id:string;user_id:string;perfil:string;ativo:boolean}|null
  roles:Array<{id:string;code:string;name:string}>
  permissions:string[]
}

export async function obterMinhaIdentidade(baseId?:string):Promise<MinhaIdentidade> {
  const query = baseId ? `?base_id=${encodeURIComponent(baseId)}` : ''
  return apiJson(`/auth/me${query}`)
}

export async function listarPapeis(baseId:string) {
  return apiJson(`/admin/roles?base_id=${encodeURIComponent(baseId)}`) as Promise<{
    items:PapelUsuario[]
    permissions:Array<{id:string;codigo:string;descricao?:string|null}>
  }>
}

export async function listarUsuarios(baseId:string) {
  return apiJson(`/admin/members?base_id=${encodeURIComponent(baseId)}`) as Promise<{items:UsuarioAdministracao[]}>
}

export async function criarUsuario(baseId:string,dados:{nome:string;email:string;roleIds:string[]}) {
  return apiJson('/admin/members',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({base_id:baseId,nome:dados.nome,email:dados.email.trim().toLowerCase(),role_ids:dados.roleIds}),
  })
}

export async function editarUsuario(baseId:string,userId:string,dados:{nome:string;ativo:boolean;roleIds:string[]}) {
  return apiJson('/admin/members',{
    method:'PATCH',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({base_id:baseId,user_id:userId,nome:dados.nome,ativo:dados.ativo,role_ids:dados.roleIds}),
  })
}

export async function excluirAcessoUsuario(baseId:string,userId:string) {
  return apiJson(`/admin/members?base_id=${encodeURIComponent(baseId)}&user_id=${encodeURIComponent(userId)}`,{method:'DELETE'})
}


export async function redefinirSenhaUsuario(baseId:string,userId:string) {
  return apiJson(`/admin/members/${encodeURIComponent(userId)}/reset-password`,{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({base_id:baseId}),
  })
}


export async function trocarMinhaSenha(password:string) {
  await neonAuth.changePassword(password)
  return apiJson('/auth/password-changed',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({})})
}


export async function revogarSessoesUsuario(baseId:string,userId:string) {
  return apiJson(`/admin/members/${encodeURIComponent(userId)}/revoke-sessions`,{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({base_id:baseId}),
  })
}
